/* esm.sh - applesauce-content@5.0.0/dist/nast/eol-metadata */
export * from "/*applesauce-content@5.0.0/esnext/dist/nast/eol-metadata.mjs";
